import { InibuildsA340Seo } from "../../../content/templateMarketing/inibuilds-a340-seo";
import { AircraftAddonTemplate } from "../../../lib/model/addonTemplate";
import a340Image from "../../images/templates/inibuilds-a340.png";

export const a340Template: AircraftAddonTemplate = {
  type: "aircraft",
  title: "iniBuilds A340",
  id: "inibuilds-a340",
  platforms: ["msfs"],
  image: a340Image,
  infoMarketingBlurb: InibuildsA340Seo,
  content: [
    {
      title: "Pre-Flight",
      roles: ["cockpitPreparation"],
      content: [
        { header: "Safety Check" },
        { item: "Parking Brake", setting: "On" },
        { item: "Speed Brake Lever", setting: "Retracted" },
        { item: "Flap Lever", setting: "Up" },
        { item: "WX Radar + PWS", setting: "Off" },
        { item: "Engine Start Selector", setting: "Norm" },
        { item: "Engine Master Switches", setting: "Off" },
        { item: "Thrust Levers", setting: "Idle, Reverse Stowed" },
        { item: "Landing Gear Lever", setting: "Down" },
        { item: "Wipers", setting: "Off" },
        { header: "Power Up" },
        { item: "Batteries", setting: "On" },
        { item: "External Power", setting: "As Req" },
        { item: "Nav & Logo Lights", setting: "On" },
        { item: "Radios", setting: "As Req" },
        { item: "Interior Lights", setting: "As Req" },
        { item: "ADIRS", setting: "Nav" },
        { header: "APU Start" },
        { item: "APU Fire Test", setting: "Perform" },
        { item: "APU Master", setting: "On" },
        { item: "APU Start", setting: "On" },
        { item: "APU", setting: "Wait for Avail" },
        { item: "APU Bleed", setting: "On" },
        { item: "Pack Fault Lights", setting: "Verify Off" },
        { item: "External Power", setting: "Off" },
      ],
    },
    {
      title: "Cockpit Preparation",
      roles: ["cockpitPreparation"],
      content: [
        { header: "Overhead Panel" },
        { item: "Oxygen Crew Supply", setting: "On" },
        { item: "ADIRS", setting: "Nav" },
        { item: "Strobe Lights", setting: "Auto" },
        { item: "Beacon Lights", setting: "Off" },
        { item: "Nav Lights", setting: "On" },
        { item: "Passenger Signs", setting: "On / Auto" },
        { item: "Emergency Exit Lights", setting: "Arm" },
        { item: "Annunciator Lights", setting: "Test, then As Req" },
        { item: "Air Conditioning", setting: "As Req" },
        { item: "Fuel Pumps", setting: "On" },
        { item: "Engine Fire Test", setting: "Perform" },
        { item: "CVR Test", setting: "Perform" },
        { item: "Overhead Panel", setting: "No White" },
        { header: "Glare Shield" },
        { item: "Altimeter", setting: "Set" },
        { item: "Flight Director", setting: "On" },
        { item: "ND Mode & Range", setting: "As Req" },
        { item: "FCU - SPD", setting: "Check Dashed" },
        { item: "FCU - HDG", setting: "Check Dashed" },
        { item: "FCU - ALT SEL", setting: "Set" },
        { item: "PFD - FMA", setting: "Check CLB | NAV" },
        { header: "Side & Main Panel" },
        { item: "Oxygen Mask", setting: "Test" },
        { item: "Stby Instruments", setting: "Check & Set" },
        { item: "Clock", setting: "Check & Set" },
        { item: "Anti-Skid & N/W Strg", setting: "On" },
        { item: "Landing Gear Lever", setting: "Down & 4 Green" },
        { item: "Brake & Accu Pressure", setting: "Check Green" },
        { header: "Pedestal" },
        { item: "Switching Panel", setting: "All Norm" },
        { item: "Thrust Levers", setting: "Idle" },
        { item: "Engine Start Selector", setting: "Norm" },
        { item: "Engine Master Switches", setting: "Off" },
        { item: "Radio Panels", setting: "As Req" },
        { item: "WX Radar + PWS", setting: "Off" },
        { item: "Transponder", setting: "Stby, Squawk Set" },
        { item: "TCAS", setting: "Stby" },
      ],
    },
    "page-break",
    {
      title: "Before Start",
      roles: ["cockpitPreparation"],
      content: [
        { item: "Takeoff Briefing", setting: "Completed" },
        { item: "Cockpit Preparation", setting: "Completed" },
        { item: "Gear Pins & Covers", setting: "Removed" },
        { item: "Passenger Signs", setting: "On / Auto" },
        { item: "ADIRS", setting: "Nav" },
        { item: "Fuel Quantity", setting: "Check" },
        { item: "Takeoff Data", setting: "Set" },
        { item: "Baro Ref", setting: "Set" },
        { item: "Cockpit Windows", setting: "Closed" },
        { item: "Cockpit Door", setting: "Locked" },
        { item: "APU", setting: "Verify On" },
        { item: "APU Bleed", setting: "Verify On" },
        { item: "External Power", setting: "Verify Off" },
        { item: "Beacon", setting: "On" },
        { item: "Thrust Levers", setting: "Idle" },
        { item: "Parking Brake", setting: "On" },
        { item: "Accu Pressure", setting: "Check Green" },
        { item: "Transponder", setting: "Auto" },
      ],
    },
    {
      title: "Engine Start",
      roles: ["afterEngineStart"],
      content: [
        { item: "Engine Start Selector", setting: "IGN / Start" },
        { item: "ENG 1 + 2 Master Switches", setting: "On" },
        { item: "ECAM Indications", setting: "Monitor" },
        { item: "ENG 3 + 4 Master Switches", setting: "On" },
        { item: "ECAM Indications", setting: "Monitor" },
        { item: "Engine Start Selector", setting: "Norm" },
      ],
    },
    {
      title: "After Start",
      roles: ["afterEngineStart", "beforeTaxi"],
      content: [
        { item: "APU Bleed", setting: "Off" },
        { item: "APU Master", setting: "Off" },
        { item: "Blue Elec Stby Hyd Pump", setting: "Off" },
        { item: "Engine & Wing Anti-Ice", setting: "As Req" },
        { item: "Engine Start Selector", setting: "Norm" },
        { item: "Flaps", setting: "Set for Takeoff" },
        { item: "Ground Spoilers", setting: "Armed" },
        { item: "Rudder & Aileron Trim", setting: "Zero" },
        { item: "Pitch Trim", setting: "Check / Set" },
        { item: "Doors", setting: "Armed" },
        { item: "ECAM Status", setting: "Check" },
        { item: "Flight Controls", setting: "Check" },
      ],
    },
    {
      title: "Taxi",
      roles: ["taxi"],
      content: [
        { item: "Nose Lights", setting: "Taxi" },
        { item: "Runway Turnoff Lights", setting: "As Req" },
        { item: "Parking Brake", setting: "Release" },
      ],
    },
    {
      title: "Before Takeoff",
      roles: ["beforeTakeoff", "takeoff"],
      content: [
        { header: "Holding Short" },
        { item: "Cabin Crew", setting: "Advise" },
        { item: "Takeoff Runway", setting: "Confirm" },
        { item: "Packs / APU Bleed", setting: "As Req" },
        { item: "Anti-Ice", setting: "As Req" },
        { item: "Terrain on ND", setting: "As Req" },
        { item: "Autobrake", setting: "Max" },
        { item: "WX Radar + PWS", setting: "On + Auto" },
        { item: "Engine Start Selector", setting: "As Req" },
        { item: "Ground Spoilers", setting: "Armed" },
        { item: "Flaps", setting: "Set" },
        { item: "Transponder", setting: "Auto" },
        { item: "TCAS", setting: "TA/RA" },
        { item: "T.O. Config Test", setting: "Perform" },
        { header: "Entering the Runway" },
        { item: "Strobe Lights", setting: "On" },
        { item: "Landing Lights", setting: "On" },
        { item: "Nose Lights", setting: "Takeoff" },
        { item: "Runway Turnoff Lights", setting: "On" },
      ],
    },
    {
      title: "After Takeoff",
      roles: ["takeoff"],
      content: [
        { item: "Autobrake", setting: "Off" },
        { item: "Landing Gear", setting: "Retracted" },
        { item: "Flaps", setting: "Retracted" },
        { item: "Ground Spoilers", setting: "Disarmed" },
        { item: "Engine Start Selector", setting: "As Req" },
        { item: "Packs", setting: "On" },
        { item: "APU Bleed", setting: "Off" },
        { item: "APU", setting: "Off" },
        { item: "Anti-Ice", setting: "As Req" },
        { header: "At Transition Altitude" },
        { item: "Altimeters", setting: "Set STD" },
        { header: "At 10,000 ft" },
        { item: "Landing Lights", setting: "Off" },
        { item: "Nose Lights", setting: "Off" },
        { item: "Runway Turnoff Lights", setting: "Off" },
        { item: "Passenger Signs", setting: "As Req" },
        { item: "Terrain on ND", setting: "As Req" },
        { item: "Pressurization", setting: "Check" },
      ],
    },
    "page-break",
    {
      title: "Cruise",
      roles: ["cruise"],
      content: [
        { item: "Anti-Ice", setting: "As Req" },
        { item: "Passenger Signs", setting: "As Req" },
        { item: "Flight Plan", setting: "Monitor" },
        { item: "Step Climbs", setting: "As Req" },
        { item: "Top of Descent", setting: "Cross Check" },
      ],
    },
    {
      title: "Descent Preparation",
      roles: ["cruise"],
      content: [
        { item: "Weather & Runway", setting: "Obtain" },
        { item: "F-PLN Approach & STAR", setting: "Check" },
        { item: "PERF Approach Page", setting: "Complete" },
        { item: "Minimums", setting: "Set" },
        { item: "Autobrake", setting: "As Req" },
        { item: "Fuel Quantity / EFOB", setting: "Check" },
        { item: "Passenger Signs", setting: "As Req" },
      ],
    },
    {
      title: "Descent",
      roles: ["approach"],
      content: [
        { item: "Speed Brakes", setting: "As Req" },
        { item: "Engine Start Selector", setting: "As Req" },
        { item: "Pressurization", setting: "Check" },
        { item: "Anti-Ice", setting: "As Req" },
        { item: "Passenger Signs", setting: "As Req" },
        { header: "At Transition Flight Level" },
        { item: "Altimeters", setting: "Set Local QNH" },
        { header: "At 10,000 Feet" },
        { item: "Landing Lights", setting: "On" },
        { item: "Nose Lights", setting: "Takeoff" },
        { item: "Runway Turnoff Lights", setting: "On" },
        { item: "Passenger Signs", setting: "On" },
        { item: "Terrain on ND", setting: "As Req" },
        { item: "Autobrake", setting: "Check" },
      ],
    },
    {
      title: "Approach",
      roles: ["approach"],
      content: [
        { item: "Approach Briefing", setting: "Complete" },
        { item: "ECAM Status", setting: "Checked" },
        { item: "Seat Belts", setting: "On" },
        { item: "Minimums", setting: "Set" },
      ],
    },
    {
      title: "Landing",
      roles: ["approach", "landing"],
      content: [
        { item: "Flaps", setting: "Set" },
        { item: "Landing Gear", setting: "Down & 4 Green" },
        { item: "Cabin Crew", setting: "Advised" },
        { item: "Ground Spoilers", setting: "Armed" },
        { item: "Autobrake", setting: "Armed" },
        { item: "ECAM Memo", setting: "Landing No Blue" },
      ],
    },
    {
      title: "After Landing",
      roles: ["landing"],
      content: [
        { item: "Strobe Lights", setting: "Auto" },
        { item: "Landing Lights", setting: "Off" },
        { item: "Nose Lights", setting: "Taxi" },
        { item: "Runway Turnoff Lights", setting: "As Req" },
        { item: "Anti-Ice", setting: "As Req" },
        { item: "APU", setting: "As Req / Start" },
        { item: "Terrain on ND", setting: "Off" },
        { item: "Autobrake", setting: "Off" },
        { item: "Brake Temperature", setting: "Check" },
        { item: "WX Radar + PWS", setting: "Off" },
        { item: "Engine Start Selector", setting: "Norm" },
        { item: "Ground Spoilers", setting: "Retract" },
        { item: "Flaps", setting: "Retract" },
        { item: "Transponder", setting: "Auto" },
        { item: "TCAS", setting: "Stby" },
      ],
    },
    {
      title: "Parking / Shutdown",
      roles: ["shutdown"],
      content: [
        { item: "Parking Brake", setting: "Set" },
        { item: "Runway Turnoff Lights", setting: "Off" },
        { item: "Nose Lights", setting: "Off" },
        { item: "APU", setting: "As Req / Start" },
        { item: "APU Bleed", setting: "As Req / On" },
        { item: "Engine Master Switches", setting: "Off" },
        { item: "Transponder", setting: "Stby" },
        { item: "TCAS", setting: "Stby" },
        { item: "Passenger Signs", setting: "Off" },
        { item: "Beacon", setting: "Off" },
        { item: "Anti-Ice", setting: "Off" },
        { item: "Fuel Pumps", setting: "Off" },
      ],
    },
    {
      title: "Securing the Aircraft",
      roles: ["shutdown"],
      content: [
        { item: "Parking Brake", setting: "As Req" },
        { item: "Oxygen Crew Supply", setting: "Off" },
        { item: "ADIRS", setting: "Off" },
        { item: "Exterior Lights", setting: "Off" },
        { item: "Emergency Exit Lights", setting: "Off" },
        { item: "Passenger Signs", setting: "Off" },
        { item: "External Power", setting: "As Req" },
        { item: "APU Bleed", setting: "As Req" },
        { item: "APU", setting: "As Req" },
        { item: "Batteries", setting: "As Req" },
      ],
    },
  ],
};
